import React, { ReactNode, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = "", ...props }) => {
  return (
    <div
      className={`bg-gray-100 shadow-sm rounded-md w-full border border-gray-300 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
